<template>
  <v-container class="advisor-page">
    <v-row>
      <v-col cols="12" sm="9" md="8" offset-md="1">
        <h1>{{ whitelabel.name }} for financial advisors. What is it?</h1>
        <p>
          If you’re a financial advisor, we can help you to scale your business
          by providing you with an online tool to help draft and manage your
          clients’ wills remotely. The {{ whitelabel.name }} platform enables
          you:
        </p>

        <ul>
          <li>to draft a high quality will for your client</li>
          <li>to calculate your clients estate administration costs</li>
          <li>
            to offer your client the opportunity to purchase a policy to cover
            these costs
          </li>
        </ul>
      </v-col>

      <v-col cols="12" sm="3">
        <v-img
          :src="require(`@/assets/${whitelabel.images.advisorPageMain}`)"
          aspect-ratio="1"
          alt="financial advisor"
          max-width="280"
          class="mx-auto"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h1 class="text-center mt-10">
          Why are more than 250 financial advisors already using
          {{ whitelabel.name }}?
        </h1>
        <v-row>
          <v-col cols="12" md="4" class="text-center">
            <v-img
              :src="
                require(`@/assets/${whitelabel.images.advisorPageWhyUseUs1}`)
              "
              aspect-ratio="1"
              alt="marketing tool"
              class="explain-image"
            />
            <p class="explain-blurb" v-if="whitelabel.name !== 'QuickWill'">
              A powerful marketing tool to acquire clients by offering them a
              free will in your own co-branded product
            </p>
            <p v-else class="explain-blurb">
              A powerful marketing tool to acquire clients by offering them a
              will in your own co-branded product
            </p>
          </v-col>
          <v-col cols="12" md="4">
            <v-img
              :src="
                require(`@/assets/${whitelabel.images.advisorPageWhyUseUs2}`)
              "
              aspect-ratio="1"
              alt="maintain close relationship"
              class="explain-image"
            />
            <p class="explain-blurb">
              Your client relationship remains yours - don’t send them off to a
              third party, help them do their will themselves
            </p>
          </v-col>
          <v-col cols="12" md="4">
            <v-img
              :src="
                require(`@/assets/${whitelabel.images.advisorPageWhyUseUs3}`)
              "
              aspect-ratio="1"
              alt="understand clients estate value"
              class="explain-image"
            />
            <p class="explain-blurb">
              Easily understand your clients estate value and their need for
              additional cover
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4" offset-md="2">
            <v-img
              :src="
                require(`@/assets/${whitelabel.images.advisorPageWhyUseUs4}`)
              "
              aspect-ratio="1"
              alt="executor"
              class="explain-image"
            />
            <p class="explain-blurb">
              Option to allow your company to be default Executor for client
              wills
            </p>
          </v-col>
          <v-col cols="12" md="4">
            <v-img
              :src="
                require(`@/assets/${whitelabel.images.advisorPageWhyUseUs5}`)
              "
              aspect-ratio="1"
              alt="dashboard to track"
              class="explain-image"
            />
            <p class="explain-blurb">
              Use our dashboard to track all your clients and advisors and their
              activities
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-8 text-center">
      <v-col cols="12" md="10" offset-md="1">
        <p v-if="whitelabel.name !== 'QuickWill'">
          {{ whitelabel.name }} is a powerful marketing tool giving financial
          advisors the ability to grow their client bases through inviting their
          networks to sign up for a FREE will, which allows for deep engagement
          and advise to be given.
        </p>
        <p v-else>
          {{ whitelabel.name }} is a powerful marketing tool giving financial
          advisors the ability to grow their client bases through inviting their
          networks to sign up for a will, which allows for deep engagement and
          advice to be given.
        </p>

        <!-- <v-btn
          rounded
          depressed
          x-large
          color="primary"
          class="mt-10"
          :href="`mailto:${whitelabel.advisorPageGetInTouchEmail}`"
        >
          Get in touch!
        </v-btn> -->

        <GradientButton
          @gradientButtonClicked="getInTouch"
          title="GET IN TOUCH!"
          :callout="''"
          class="mt-10"
        />
      </v-col>
    </v-row>

    <div v-if="whitelabel.advisorPageShowPartnerLogos">
      <v-row align="center" class="d-flex flex-column align-center mt-10">
        <v-col cols="12">
          <h1 class="text-center mt-10">Some of our partners</h1>
        </v-col>
        <div>
          <a href="http://www.eqfin.co.za" target="_blank">
            <v-img
              :width="173.5"
              :src="require('@/assets/quickwill/advisor-page/Eqfin.png')"
              alt="Eqfin"
            />
          </a>
        </div>
      </v-row>
      <v-row align="center" class="mt-5">
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/AlexBabich.png')"
            alt="Alex Babich"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/CrueInvest.png')"
            alt="Crue Invest"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/EmphasisWealth.png')"
            alt="Emphasis Wealth"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/ExcelLife.png')"
            alt="Excel Life"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/Greengrass.png')"
            alt="Greengrass"
          />
        </v-col>
        <!-- <v-col cols="4" sm="3" md="2">
          <v-img :src="require('@/assets/quickwill/advisor-page/Multinet.png')" alt="Multinet" />
        </v-col> -->
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/WMD.png')"
            alt="WMD"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/MultiTrust.png')"
            alt="Multi Trust"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/Netto.png')"
            alt="Netto"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/NetworthUltd.png')"
            alt="Networth Unlimited"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/NLD.png')"
            alt="NLD"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/Obin.png')"
            alt="Obin"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/PAS.png')"
            alt="PAS"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/RetireAtHome.png')"
            alt="Retire at Home"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/RichIdeas.png')"
            alt="Rich Ideas"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/SimpleWealth.png')"
            alt="Simple Wealth"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <a href="https://www.taxtim.com" target="_blank">
            <v-img
              :src="require('@/assets/quickwill/advisor-page/TaxTim.png')"
              alt="Tax Tim"
            />
          </a>
        </v-col>
        <v-col cols="4" sm="3" md="2" offset-sm="1" offset-md="0">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/TorrFin.png')"
            alt="Torr Fin"
          />
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-img
            :src="require('@/assets/quickwill/advisor-page/Verso.png')"
            alt="Verso"
          />
        </v-col>
        <!-- <v-col cols="4" sm="3" md="2" offset="4" offset-sm="0" offset-md="5">
          <v-img :src="require('@/assets/quickwill/advisor-page/WMD.png')" alt="WMD" />
        </v-col> -->
      </v-row>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: 'AdvisorPage',
    methods: {
      getInTouch() {
        window.location.href = `mailto:${this.whitelabel.advisorPageGetInTouchEmail}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .advisor-page {
    max-width: 1185px;

    h1 {
      margin-bottom: 15px;
    }

    .explain-image {
      max-width: 190px;
      margin: 0 auto;
    }

    .explain-blurb {
      max-width: 300px;
      margin: 10px auto;
      text-align: center;
    }

    .advisor-price-block {
      max-width: 250px;
      margin: 0 auto;

      .referral-fee {
        font-size: 13px;
      }

      .advisor-price {
        // Background color moved to global.css due to IE issues
        border: 1px solid white;
        border-radius: 8px 8px 0px 0px;
        height: 70px;

        hr {
          margin-left: 70px;
          margin-right: 70px;
        }
      }

      .advisor-price-detail {
        // Background color moved to global.css due to IE issues
        border: 1px solid white;
        border-radius: 0px 0px 8px 8px;
        min-height: 220px;

        p {
          padding: 10px 15px 0 15px;
        }
      }
    }

    .pricing-add-note {
      margin: 14px auto 0 auto;
      font-weight: bold;
      font-size: 13px;
    }
  }
</style>
